import { css, FlattenSimpleInterpolation } from "styled-components";
import { isMobileDevice } from "./mobile";
import { inIframe } from "./embed";

enum MediaBreakPoint {
  giant = "giant",
  desktop = "desktop",
  desktopEmbedSafe = "desktopEmbedSafe",
  tablet = "tablet",
  phone = "phone"
}

type MediaSizes = {
  [key in MediaBreakPoint]: number;
};

// TODO: revist ty
type Media = {
  [key in MediaBreakPoint]: any;
};

export const mediaSizes: MediaSizes = {
  giant: isMobileDevice() || inIframe() ? 9999 : 1170,
  desktop: isMobileDevice() || inIframe() ? 9999 : 840,
  desktopEmbedSafe: isMobileDevice() ? 9999 : 840,
  tablet: 768,
  phone: 300
};

const calcMediaBreakPoint = (
  breakpoint: MediaBreakPoint
): ((first: any, ...args: any[]) => FlattenSimpleInterpolation) => {
  const emSize = mediaSizes[breakpoint] / 16;
  return (first: any, ...args: any[]): FlattenSimpleInterpolation => css`
    @media (min-width: ${emSize}em) {
      ${css(first, ...args)};
    }
  `;
};

// // Usage
// const Container = styled.div`
//   color: #333;
//   ${media.desktop`padding: 0 20px;`}
//   ${media.tablet`padding: 0 10px;`}
//   ${media.phone`padding: 0 5px;`}
// `
const media: Media = {
  giant: calcMediaBreakPoint(MediaBreakPoint.giant),
  desktop: calcMediaBreakPoint(MediaBreakPoint.desktop),
  desktopEmbedSafe: calcMediaBreakPoint(MediaBreakPoint.desktopEmbedSafe),
  tablet: calcMediaBreakPoint(MediaBreakPoint.tablet),
  phone: calcMediaBreakPoint(MediaBreakPoint.phone)
};

export default media;
